export default class CACA1080RequestModel {
  /**
   * 商品番号
   */
  productNo: string

  /**
   * 当社商品コード
   */
  shhnCd: string
}
